export default {
	methods: {
		formatMoney(money, precision = 2, divideThrough = 100) {
			return new Intl.NumberFormat('de-DE', { minimumFractionDigits: precision, style: 'currency', currency: 'EUR' }).format(money / divideThrough);
		},
		formatNumber(number, precision = 0, divideThrough = 1) {
			return new Intl.NumberFormat('de-DE', { minimumFractionDigits: precision }).format(number / divideThrough);
		},
	},
};
